<script>
import { onMount } from "svelte";

export let logo;
export let title;
export let text;
export let button_text;
export let button_link = undefined;
export let button_function = undefined;
export let button_color_reversed = false;
export let show_dropshadows = false;
export let delay = 0;
export let new_window = false;

let callout_element;
onMount(async() => {
    // callout_element.style.setProperty("animation-delay", `${delay}s`);
    // callout_element.style.setProperty("animation", `createCallout 0.5s`);
    
});
// red.style.setProperty('--animation-time', duration +'s');
// animation: createCallout 0.5s;
// animation-delay: 0ms;

$: button_class = (button_color_reversed) ? "button_reversed" : "button_normal";

function doClick(){
    // console.log("doing click here");
    if(button_link !== undefined){
        if(new_window){
            window.open(button_link, '_blank');
        }else{
            window.location.href = button_link;
        }
    }else if(button_function !== undefined){
        button_function();
    }
}

</script>

<div bind:this={callout_element} class="calloutcontainer {(show_dropshadows) ? "shadowed" : ""}">
    <div class="iconcontainer"><img src="{logo}" alt="icon"/></div>
    <div class="titlecontainer">{title}</div>
    <div class="textcontainer">{text}</div>
    <div class="buttoncontainer"><button on:click={()=>{doClick();}} class="darken {button_class}">{button_text}</button></div>
</div>

<style>

.calloutcontainer {
    background-color: white;
    border-radius: 5px;
    width: 200px;
    height: 260px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 25px;
    animation: createCallout 0.5s;
    animation-timing-function: ease-out;
}

@keyframes createCallout {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}
.shadowed {
    /* color: var(--lightgray); */
    box-shadow: 5px 5px 20px #ccc;
}
.iconcontainer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.iconcontainer img {
    width: 42px;
    height: 42px;
}
.titlecontainer {
    margin-top: 15px;
    width: 100%;
    text-align: center;
    font-weight:600;
    font-size: 1.25em;
}
.textcontainer {
    margin-top: 20px;
    width: 100%;
    text-align: center;
    font-weight: normal;
    font-size: 1em;
    line-height: 1.5em;
    color: #737a83;
}
.buttoncontainer {
    width: 100%;
    padding: 12px;
}
.buttoncontainer button {
    width: 100%;
    padding: 10px;
    border: solid 1px;
    border-radius: 5px;
    cursor: pointer;
    border-color: var(--semperred);
    color: var(--semperred);
    background-color: white;
    transition: all 0.25s linear;
}
/* .button_reversed, .button_normal:hover {
    border-color: var(--semperred);
    color: white;
    background-color: var(--semperred);
} */
/* .button_normal {
    border-color: var(--semperred);
    color: var(--semperred);
    background-color: white;
} */

@media (max-device-width: 1200px), (max-width: 1199px) {
    .calloutcontainer {
        margin-bottom: 20px;
        /* width: 55%; */
        /* height: calc(55% * 1.275); */
        width: 220px;
        height: 260px;

    }
    .titlecontainer {
        font-size: 1.5em;
    }

}

</style>